import React, { useEffect, useState } from "react";
import { Grid, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { Field } from "modules/app/components/ContactDetails/Details/styles";
import { CompanyTeamsRule, SubmitRule, UsersRule } from "../fields";
import { NameRule } from "../fields/NameRule";

function ByAttribute({
  users,
  teams,
  options,
  handleSubmit,
  distribution_type,
  company_id,
  rule,
}) {
  const defaultFields = [];
  const defaultValues = {
    users: rule.user_ids || [],
    company_teams: rule.company_team_ids || [],
  };

  if (Object.keys(rule).length > 0) {
    Object.keys(rule.conditionals).forEach((key) => {
      if (options.distribution_conditionals[key]) {
        const value = {
          id: key,
          label: options.distribution_conditionals[key],
        };

      if(key === "type_negotiation"){
              defaultValues[key] = {
                id: rule.conditionals.type_negotiation,
                label: options.property_finalities[rule.conditionals.type_negotiation]
              }
      } else {
              defaultValues[key] = rule.conditionals[key];
      }
      defaultFields.push(value);
      }
    });

    Object.keys(rule).forEach((key) => {
      defaultValues[key] = rule[key];
    });

  }

  const [attributes, setAttributes] = useState(defaultValues);
  const [fields, setFields] = useState(defaultFields);
  const [errors, setErrors] = useState({});

  function handleClick(event) {
    event.preventDefault();

    const conditionals = {};

    fields.forEach((field) => {
      conditionals[field.id] = attributes[field.id]?.id || attributes[field.id];
    });

    const data = {
      rule: {
        company_id: company_id,
        priority: rule?.priority || 99,
        distribution_type: distribution_type,
        routing: "RoundRobin",
        name: attributes.name,
        conditionals: conditionals,
        user_ids: attributes.users,
        company_team_ids: attributes.company_teams,
      },
    };
    handleSubmit(data);
  }

  useEffect(() => {
    const validationErrors = {};

    if (attributes.users.length == 0 && attributes.company_teams.length == 0) {
      validationErrors.usersOrCompanyTeams =
        "É necessário ao menos um usuário ou uma equipe";
    }

    if (fields.length == 0) {
      validationErrors.fields = "Selecione ao menos um critério";
    }

    if (!attributes.name) {
      validationErrors.name = "Campo obrigatório";
    }

    fields.forEach((field) => {
      if (!attributes[field.id]) {
        validationErrors[field.id] = "Campo obrigatório";
      }
    });

    setErrors(validationErrors);
  }, [attributes, fields]);

  return (
    <>
      <div
        style={{
          marginTop: "28px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <NameRule
          attributes={attributes}
          setAttributes={setAttributes}
          errors={errors}
        />

        <Grid
          container
          alignItems="center"
          spacing={1}
          style={{ marginBottom: "20px" }}
        >
          <Grid item style={{ textAlign: "right", width: "20%" }}>
            Critérios
          </Grid>

          <Grid item style={{ width: "50%" }}>
            <Autocomplete
              defaultValue={fields}
              style={{ marginTop: 20 }}
              options={Object.keys(options.distribution_conditionals).map(
                (field) => ({
                  id: field,
                  label: options.distribution_conditionals[field],
                })
              )}
              multiple
              fullWidth
              onChange={(_event, value) => {
                value.forEach((item) => {
                  const found = fields.find((field) => field.id == item.id);

                  if (!found) {
                    setAttributes({
                      ...attributes,
                      [item.id]: "",
                    });
                  }
                });

                setFields(value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Critérios"
                  variant="outlined"
                  helperText={errors.fields}
                />
              )}
              getOptionLabel={(field) => field.label}
              getOptionSelected={(option, value) => option.id === value.id}
            />
          </Grid>
        </Grid>

        {fields.map((field) => (
          <Grid key={field.id} container alignItems="center" spacing={1}>
            <Grid item style={{ textAlign: "right", width: "20%" }}>
              {field.label}
            </Grid>

            <Grid item style={{ width: "50%" }}>
              {field.id == "type_negotiation" ? (
                <Autocomplete
                  style={{ marginTop: 20 }}
                  options={Object.keys(options.property_finalities).map(
                    (negotiation_type) => ({
                      id: negotiation_type,
                      label: options.property_finalities[negotiation_type],
                    })
                  )}
                  openOnFocus={true}
                  fullWidth
                  renderInput={(params) => (
                    <Field
                      {...params}
                      label={field.label}
                      variant="outlined"
                      helperText={errors[field.id]}
                    />
                  )}
                  value={attributes[field.id] || ""}
                  getOptionLabel={(negotiation_type) => negotiation_type.label}
                  getOptionSelected={(option, value) => option.id === value.id}
                  onChange={(e, value) =>
                    setAttributes({ ...attributes, [field.id]: value })
                  }
                />
              ) : (
                <Field
                  name={field.id}
                  label={!attributes[field.id] && field.label}
                  value={attributes[field.id] || ""}
                  variant="outlined"
                  helperText={errors[field.id]}
                  onChange={(e) =>
                    setAttributes({ ...attributes, [field.id]: e.target.value })
                  }
                />
              )}
            </Grid>
          </Grid>
        ))}

        <CompanyTeamsRule
          rule={rule}
          attributes={attributes}
          setAttributes={setAttributes}
          errors={errors}
          teams={teams}
        />

        <UsersRule
          rule={rule}
          attributes={attributes}
          setAttributes={setAttributes}
          errors={errors}
          users={users}
        />

        <SubmitRule
          disabled={Object.keys(errors).length > 0}
          handleClick={handleClick}
          rule={rule}
        />
      </div>
    </>
  );
}

export default ByAttribute;
